import { useAllTokens } from './useTokens'
import { Token } from '@/constants/tokens/types'

export const useNativeToken = (): Token | undefined => {
  const allTokens = useAllTokens()
  if (!allTokens) { return }
  return allTokens.find(token => token.isNative) || undefined
}
